import selectOption from '@/store/dict/selectOptionDict'

export default {
  data() {
    return {
      paginationData: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
        pageSizes: [5, 10, 20, 50],
      },
      headData: [
        {
          name: 'id',
          columnProps: {
            prop: 'id',
            label: '收款ID',
            width: 110,
          },
          render: ({ row }) => {
            if (!this.judgePermission('finance_batch_receivable_record_detail')) return row.id
            return <span class="a-hover-link" onClick={() => this.viewDetails(row)}>{row.id}</span>
          },
        },
        {
          name: 'amount',
          columnProps: {
            prop: 'amount',
            label: '收款金额（元）', // 新添加的车辆状态
            width: 120,
          },
          getText: ({ row }) => this.numberWithCommas(row.amount),
        },
        {
          name: 'payMethod',
          columnProps: {
            prop: 'payMethod',
            label: '支付方式',
            width: 160,
          },
          getText: ({ row }) => selectOption.payMethods[row.payMethod],
        },
        {
          name: 'state',
          columnProps: {
            prop: 'state',
            label: '收款状态',
          },
          getText: ({ row }) => selectOption.batchStateDict[row.state],
        },
        {
          name: 'gmtCreate',
          columnProps: {
            prop: 'gmtCreate',
            label: '创建时间',
            width: 160,
          },
        },
        {
          name: 'completeTime',
          columnProps: {
            prop: 'completeTime',
            label: '完成时间',
            width: 160,
          },
        },
        {
          name: 'discardTime',
          columnProps: {
            prop: 'discardTime',
            label: '作废时间',
            width: 160,
          },
        },
        {
          name: 'discardDesc',
          columnProps: {
            prop: 'discardDesc',
            label: '作废原因',
          },
        },
        {
          name: 'createUserName',
          columnProps: {
            prop: 'createUserName',
            label: '创建人',
          },
        },
      ],
    }
  },
  methods: {
    // 分页效果
    paginationChange(payload) {
      const { pagination } = payload
      this.paginationData.pageSize = pagination.pageSize
      this.paginationData.pageNum = pagination.pageNum
      this.getBatchCollectionRecordList()
    },
  },
}
